var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 2.25V21.75H19.875V9.05786C19.875 8.29399 19.6053 7.55435 19.114 6.96973L15.791 3.01611C15.383 2.53049 14.7812 2.25 14.1467 2.25H4.125ZM5.625 3.75H13.7607C14.9945 3.75 15.375 4.2619 15.375 4.71753C15.375 5.3869 14.625 6.375 14.625 6.375C18.2854 8.1075 18.3062 8.10696 18.3062 9.44458C18.3062 11.3196 18.375 20.25 18.375 20.25H5.625V3.75ZM8.25 9.75V11.25H15.75V9.75H8.25ZM8.25 12.75V14.25H15.75V12.75H8.25ZM8.25 15.75V17.25H13.125V15.75H8.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon-document.73efacf5cd4c996635cc2c687fd4b467.svg";
export { ForwardRef as ReactComponent };